import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';

import * as actions from './actions';
import {
    GET_ME,
    GET_ORGANIZATION_MEMBERS,
    SET_ME,
    SET_ME_LOADING_FALSE,
    SET_ORGANIZATION_MEMBERS,
    SET_ORGANIZATION_MEMBERS_LOADING_FALSE,
    SET_USER_LOCKED,
    SET_USER_RESTRICTION,
} from './constants';

import { Me, Member, MemberRole, MemberStatus } from '@/shared/api/organization';

export type OrganizationState = {
    info: Me;
    infoLoading: boolean;
    locked: boolean;
    organizationMembers: Member[];
    organizationMembersLoading: boolean;
    restriction: boolean;
};

export const MeDefault = {
    name: '',
    email: '',
    organization: {
        id: 0,
        name: '',
    },
    restriction: false,
};

export const MemberDefault = {
    name: '',
    email: '',
    role: MemberRole.ADMIN,
    status: MemberStatus.ACTIVE,
    lastSeen: '',
};

const defaultState: OrganizationState = {
    info: MeDefault,
    infoLoading: false,
    locked: false,
    organizationMembers: [MemberDefault],
    organizationMembersLoading: false,
    restriction: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function me(state = defaultState, action: OrderAction): OrganizationState {
    switch (action.type) {
        case GET_ME: {
            return {
                ...state,
                infoLoading: true,
            };
        }
        case SET_ME: {
            LocalStorage.setItem(LOCAL_STORAGE.LOGGED_IN, 'true');
            return {
                ...state,
                info: action.payload,
                infoLoading: false,
            };
        }
        case SET_USER_LOCKED: {
            return {
                ...state,
                locked: action.payload,
            };
        }
        case SET_ME_LOADING_FALSE: {
            return {
                ...state,
                infoLoading: false,
            };
        }
        case GET_ORGANIZATION_MEMBERS: {
            return {
                ...state,
                organizationMembersLoading: true,
            };
        }
        case SET_ORGANIZATION_MEMBERS: {
            return {
                ...state,
                organizationMembers: action.payload,
                organizationMembersLoading: false,
            };
        }
        case SET_ORGANIZATION_MEMBERS_LOADING_FALSE: {
            return {
                ...state,
                organizationMembersLoading: false,
            };
        }
        case SET_USER_RESTRICTION: {
            return {
                ...state,
                restriction: true,
            };
        }
        default: {
            return state;
        }
    }
}
